/**
 * Joins the final two words of a string with a non-breaking space so a single
 * trailing word never wraps onto its own line ("orphan"). Does not cross a hard
 * line break.
 *
 * Shared owner: the design-system `Text` component applies this at render, and
 * the device-farm atom compiler derives the same variant so exact-match text
 * selectors keep matching rendered copy. Both MUST agree, so the transform lives
 * here rather than being re-implemented per consumer.
 */
export function preventOrphan(text: string): string {
  return text.replace(/[^\S\n]+(\S+)[^\S\n]*$/, '\u00A0$1');
}
